// @ts-nocheck

import { filter } from 'lodash';
import { createSelector } from 'reselect';

import { selectBasketSystems } from '../../selectors/basket/basketPrimary.selector';
import { selectBasketNbBetsSystem } from '../../selectors/basketCommon.selector';

const selectFilteredSystem = createSelector([selectBasketSystems], (systems) => {
  return filter(systems, (system) => system.checked).map((system) => {
    const { title, count } = system;
    return {
      label: title,
      counter: count,
    };
  });
});

const selectBasketCombinationsSummaryProps = createSelector(
  [selectFilteredSystem, selectBasketNbBetsSystem],
  (combinations, counter) => ({
    combinations,
    counter,
  }),
);

export default selectBasketCombinationsSummaryProps;
